import PropTypes from 'prop-types';
import isRTL from '../v2/utils/isRTL';

const ChevronRightIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 25"
    height="100%"
    fill="#fff"
    data-test="ChevronRightIcon"
    transform={props.rtlSensitive && isRTL() ? 'rotate(180)' : undefined}
  >
    <path d="M9 16.137L13.22 12 9 7.863 10.39 6.5 16 12 10.39 17.5z" transform="translate(0 1)" />
  </svg>
);

ChevronRightIcon.propTypes = {
  rtlSensitive: PropTypes.bool,
};

ChevronRightIcon.defaultProps = {
  rtlSensitive: false,
};

export default ChevronRightIcon;
